import EditIcon from '@mui/icons-material/Edit'
import { TabContext, TabPanel } from '@mui/lab'
import TabList from '@mui/lab/TabList'
import { Divider, IconButton, Typography } from '@mui/material'
import { GetCompanyQuery } from '__generated__/graphql'
import React from 'react'
import { ContactGroups } from 'recruiter/types/ContactGroups'
import { getPxAsRem } from 'shared/utils'
import EditCpiContacts from '../EditCPIContacts'
import {
    ContactChip,
    ContactRow,
    Header,
    StyledCard,
    StyledTab,
} from './styled'

interface CpiContactsProps {
    data: GetCompanyQuery
    refetch: () => void
}

const ContactCard = ({ contact, contactType }) => {
    const nickname = contact.recruiter?.user?.nickname
    const firstName = contact.recruiter?.user?.firstName || '-'
    const lastName = contact.recruiter?.user?.lastName || '-'

    return (
        <ContactRow>
            <Typography
                variant="body1"
                title={`${firstName} ${lastName}`}
            >{`${nickname ?? firstName} ${lastName}`}</Typography>
            <ContactChip label={contactType} />
        </ContactRow>
    )
}

const renderContacts = (contacts, group: ContactGroups) => {
    const filteredContacts =
        contacts?.filter((contact) => contact.group === group) || []
    if (filteredContacts.length === 0) {
        return (
            <Typography
                variant="body1"
                textAlign="center"
                sx={{ padding: getPxAsRem(28) }}
            >
                No contacts available.
            </Typography>
        )
    }

    return filteredContacts.map((contact, index) => (
        <React.Fragment key={contact.id}>
            <ContactCard
                contact={contact}
                contactType={contact.contactType || '-'}
            />
            {index !== filteredContacts.length - 1 && <Divider />}
        </React.Fragment>
    ))
}

const CpiContacts: React.FC<CpiContactsProps> = ({ data, refetch }) => {
    const [selectedTab, setSelectedTab] = React.useState<string>(
        ContactGroups['Pre-MBA']
    )
    const [editContact, setEditContact] = React.useState(false)

    const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
        setSelectedTab(newValue)
    }

    return (
        <>
            <EditCpiContacts
                open={editContact}
                onClose={() => {
                    setEditContact(!editContact)
                }}
                refetch={refetch}
                data={data}
            />
            <StyledCard>
                <Header>
                    <Typography variant="h4">CPI Contacts</Typography>
                    <IconButton
                        size="small"
                        onClick={() => setEditContact(true)}
                    >
                        <EditIcon fontSize="small" />
                    </IconButton>
                </Header>
                <TabContext value={selectedTab}>
                    <TabList
                        onChange={handleChange}
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        {Object.values(ContactGroups).map((group) => (
                            <StyledTab
                                key={group}
                                label={group}
                                value={group}
                            />
                        ))}
                    </TabList>
                    <Divider />
                    {Object.values(ContactGroups).map((group) => (
                        <TabPanel key={group} value={group} sx={{ padding: 0 }}>
                            {renderContacts(
                                data.company?.recruiterContacts,
                                group
                            )}
                        </TabPanel>
                    ))}
                </TabContext>
            </StyledCard>
        </>
    )
}

export default CpiContacts
